'use client';

import { useEffect, useState } from 'react';

const frames: { src: string; alt: string }[] = [
  { src: '/screenshots/app/iphone-home.png', alt: 'Cool Mate home screen' },
  { src: '/screenshots/app/iphone-challenge.png', alt: 'A challenge in progress' },
  { src: '/screenshots/app/iphone-progress.png', alt: 'Learning progress dashboard' },
  { src: '/screenshots/app/iphone-collection.png', alt: 'A curated collection' },
];

export function HeroPhoneRotator(): React.JSX.Element {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      return;
    }
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % frames.length);
    }, 4000);
    return (): void => clearInterval(id);
  }, []);

  return (
    <div className="relative inline-block -rotate-3">
      <div className="relative rounded-4xl bg-gray-950 p-1 shadow-2xl shadow-gray-900/30 ring-1 ring-foreground/10">
        <div
          className="relative overflow-hidden rounded-[1.75rem]"
          style={{ aspectRatio: '1320 / 2868', width: '260px' }}
        >
          {frames.map((frame, i) => (
            <img
              key={frame.src}
              src={frame.src}
              alt={frame.alt}
              loading={i === 0 ? undefined : 'lazy'}
              fetchPriority={i === 0 ? 'high' : undefined}
              decoding="async"
              className="absolute inset-0 h-full w-full object-contain transition-opacity duration-700"
              style={{ opacity: i === index ? 1 : 0 }}
            />
          ))}
        </div>
      </div>
      <div className="absolute -inset-6 -z-10 rounded-[3rem] bg-linear-to-br from-pink-200/40 via-fuchsia-200/30 to-violet-200/40 blur-3xl" />
    </div>
  );
}
